import { render, staticRenderFns } from "./CreatePrestation.vue?vue&type=template&id=0270607d&"
import script from "./CreatePrestation.vue?vue&type=script&lang=ts&"
export * from "./CreatePrestation.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePrestation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports